import { combineReducers } from 'redux';
import {
  EMPLOYEE_LIST_SET_EMPLOYEES,
  EMPLOYEE_LIST_SET_DELETED_EMPLOYEE,
  EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_SET_OUTLETS,
  EMPLOYEE_LIST_SET_CHECKED_OUTLETS,
  EMPLOYEE_LIST_SET_PROFILE,
} from 'actions/employees/list/constants';

import createReducer from 'utils/createReducer';

const checkedOutlets = createReducer([], {
  [EMPLOYEE_LIST_SET_CHECKED_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const deletedEmployee = createReducer(null, {
  [EMPLOYEE_LIST_SET_DELETED_EMPLOYEE]: (draft, { payload }) =>
    payload.deletedEmployee,
});

const employees = createReducer([], {
  [EMPLOYEE_LIST_SET_EMPLOYEES]: (draft, { payload }) => payload.employees,
});

const outlets = createReducer([], {
  [EMPLOYEE_LIST_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const profile = createReducer(null, {
  [EMPLOYEE_LIST_SET_PROFILE]: (draft, { payload }) => payload.profile,
});

const showAssignOutletModal = createReducer(false, {
  [EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL]: () => true,
  [EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL]: () => false,
});

const showDeleteEmployeeModal = createReducer(false, {
  [EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL]: () => true,
  [EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL]: () => false,
});

export default combineReducers({
  checkedOutlets,
  deletedEmployee,
  employees,
  outlets,
  profile,
  showAssignOutletModal,
  showDeleteEmployeeModal,
});
